import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FlexLayoutModule } from "@angular/flex-layout";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import {
  MatButtonModule,
  MatCardModule,
  MatCheckboxModule,
  MatDialogModule,
  MatGridListModule,
  MatIconModule,
  MatInputModule,
  MatProgressSpinnerModule,
  MatRadioModule,
  MatSelectModule,
  MatSnackBarModule,
  MatTableModule,
} from "@angular/material";
import { StateProvider } from "@uirouter/angularjs";
import * as angular from "angular";
import { downgradeComponent } from "@angular/upgrade/static";
import { GooglePlacesModule } from "@mandae/ng-utils/google-places";
import { TextMaskModule } from "angular2-text-mask";
import { DashboardModule } from "../dashboard/dashboard.module";
import { PipesModule } from "../pipes/pipes.module";
import { ServicesModule } from "../services/services.module";
import { AddressFormComponent } from "./address/address-form/address-form.component";
import { AddressModule } from "./address/address.module";
import { IntegrationModule } from "./integration/integration.module";
import { ProfileRoutingModule } from "./profile-routing.module";
import { SettingsModule } from "./settings/settings.module";
import { GetDataComponent } from "./get-data/get-data.component";

@NgModule({
  imports: [
    AddressModule,
    CommonModule,
    SettingsModule,
    DashboardModule,
    FlexLayoutModule,
    FormsModule,
    GooglePlacesModule,
    IntegrationModule,
    MatButtonModule,
    MatCardModule,
    MatCheckboxModule,
    MatDialogModule,
    MatGridListModule,
    MatIconModule,
    MatRadioModule,
    MatSelectModule,
    MatSnackBarModule,
    MatProgressSpinnerModule,
    MatInputModule,
    MatTableModule,
    PipesModule,
    ProfileRoutingModule,
    ReactiveFormsModule,
    ServicesModule,
    TextMaskModule,
  ],
  declarations: [GetDataComponent],
  entryComponents: [AddressFormComponent, GetDataComponent],
  exports: [],
})
export class ProfileModule {}

try {
  angular
    .module("mandaeApp")
    .directive(
      "appGetData",
      downgradeComponent({ component: GetDataComponent })
    )
    .config([
      "$stateProvider",
      ($stateProvider: StateProvider) => {
        $stateProvider.state({
          name: "get-data",
          url: "/get-data",
          component: "appGetData",
        });
      },
    ]);
} catch (e) {}
